import React, { useEffect, useState } from 'react'
import './App.css'
import Drink from './components/Drink.js'
import Main from './components/Main.js'
import Antre from './components/Antre.js'
import Desserts from './components/Desserts'
import Salad from './components/Salad'
import Other from './components/Other'
import Breakfast from './components/Breakfast'
import Translator from './Translator.js'
import Modal from './components/Modal.js'
import { useModalContext } from './context/ModalContext.js'
 

function App() {
  const [show, setShow] = useState(0)
  const [locale, setLocale] = useState('/') 
  const {showModal, setShowModal, data, setData} = useModalContext() 
  const [userLanguage, setUserLanguage] = useState('');
  let l = Translator()
 

  useEffect(() => {
    let locale = window.location.pathname
    setLocale(locale) 
    const language = navigator.language.split('-')[0]; // Get the user's language preference
    setUserLanguage(language);

    let flag = document.getElementById('flags')
    let fla = document.getElementById('fl')

    flag.addEventListener('mouseover', () => {
      fla.className = ' fixed flex flex-col z-50 p-3 bg-[rgba(0,0,0,0.4)] mt-4'
    })
    flag.addEventListener('mouseout', () => {
      fla.className = 'hidden'
    })
  })




  return (
    <div className="flex flex-col bg-white dark:bg-slate-800 dark:text-white text-black ">
      {showModal ? <Modal></Modal> : <></>}

      <div className="flex flex-row justify-evenly">
        <div className="flex flex-col">
          <div className="flex">
            <h1 className="text-4xl px-2 font-bold">
              Demlik<span className="text-red-600">Cafe</span>
            </h1>
          </div>
          <div className="flex px-2 pb-2 text-md">Sinop / Güzelkent</div>
        </div>

        <div className="flex flex-col">
          <div className="flex">
            <h1 className="text-4xl px-2">Menu</h1>
          </div>
          <div id="flags" className="flex flex-col ml-5">
            {locale === '/en' ? (
              <>
                <img src="./images/en.jpg" alt="en" width="50px" />
              </>
            ) : locale === '/de' ? (
              <>
                <img src="./images/de.png" alt="de" width="50px" />
              </>
            ) : locale === '/tr' ? (
              <>
              <img src="./images/tr.png" alt="tr" width="50px" />
              </>
            ) : (
              <>
                <img src="./images/tr.png" alt="tr" width="50px" />
              </>
            )}

            <div id="fl" className="hidden">
              <div className="cursor-pointer my-1">
                <a href="/de">
                  <img src="./images/de.png" alt="de" width="50px" />
                </a>
              </div>
              <div className="cursor-pointer my-1">
                <a href="/en">
                  <img src="./images/en.jpg" alt="en" width="50px" />
                </a>
              </div>
              <div className="cursor-pointer my-1">
                <a href="/tr">
                  <img src="./images/tr.png" alt="tr" width="50px" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center w-screen items-center overflow-x-auto border-y-4 dark:border-gray-700 border-gray-700">
        <div className="flex flex-row items-center p-1">
          <div
            onClick={() => setShow(0)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn1}
          </div>
          <div
            onClick={() => setShow(1)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn2}
           </div>
           </div>
        <div className="flex flex-row items-center p-1">
          <div
            onClick={() => setShow(3)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn3}
          </div>
   
          <div
            onClick={() => setShow(2)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn4}
          </div>
          <div
            onClick={() => setShow(4)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn5}
          </div>
        </div>
        <div className="flex flex-row items-center p-1">
          <div
            onClick={() => setShow(5)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn6}
          </div>
          <div
            onClick={() => setShow(6)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn7}
          </div>
          <div
            onClick={() => setShow(7)}
            className="cursor-pointer font-bold bg-[rgba(37,99,235,0.5)] mx-1 p-2 rounded-md hover:bg-[rgba(0,99,245,0.9)] text-center"
          >
          {l.Main.btn8}
          </div>
        </div>
      </div>
      <div className="mt-10 text-center font-semibold bg-yellow-600 text-lg">
      Click the flag to change language!
      </div>
      {/* <div className="mt-2 text-center font-semibold bg-yellow-600 text-lg">
      Click on the names to see the pictures!
      </div> */}
      
      {show === 1 ? (
        <>
          <Main></Main>
        </>
      ) : show === 2 ? (
        <Antre></Antre>
      ) : show === 3 ? (
        <Drink></Drink>
      ) : show === 4 ? (
        <Desserts></Desserts>
      )
      : show === 5 ? 
       <Salad></Salad>
        : show === 6 ?
       <Breakfast></Breakfast>
        : show === 7 ? 
        <Other></Other>
        :(
        <>
          <Breakfast></Breakfast>
          <Antre></Antre>
          <Salad></Salad>
          <Main></Main>
          <Desserts></Desserts>
          <Drink></Drink>
          <Other></Other>
        </>
      )}
      <div className="text-center w-full font-mono dark:text-white text-white dark:bg-none bg-black">© DemlikCafe 2023 Created by <a className="underline  hover:text-blue-600 visited:text-red-600" href="https://www.linkedin.com/in/murat-memis/" rel='nopeener' target='_blank'>Aki</a></div>
    </div>
  )
}

export default App
